export enum LayoutLocations {
	Default,
	RightHandMenu,
	Top,
	Hidden
}

export const LayoutLocationsLabels = [
	{
		key: LayoutLocations.Default,
		label: "Default",
		details: "Appears in main section"
	},
	{
		key: LayoutLocations.RightHandMenu,
		label: "Right-hand Menu",
		details: "Appears in right-hand section"
	},
	{
		key: LayoutLocations.Top,
		label: "Top",
		details: "Appears in main section, above Attachments"
	},
	{
		key: LayoutLocations.Hidden,
		label: "Hidden",
		details: "Fields are added but not shown"
	}
]
